import { AlertCircle } from 'lucide-react';

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="max-w-md w-full mx-4 bg-white rounded-2xl border border-gray-100 shadow-sm p-10 text-center">
        <AlertCircle className="h-12 w-12 text-red-400 mx-auto" />
        <h2 className="mt-4 text-lg font-semibold text-gray-900">Careers page not found</h2>
        <p className="mt-2 text-gray-400 text-sm">Please check the URL and try again.</p>
      </div>
    </div>
  );
}
